import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { selectCurrentUser, selectRootAdmin } from 'store/reducer/appReducer';

interface RootOnlyGuardProps {
  children: ReactNode;
}

const RootOnlyGuard = ({ children }: RootOnlyGuardProps) => {
  const user = useSelector(selectCurrentUser);
  const isRootAdmin = useSelector(selectRootAdmin);

  // If user is not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If not root admin, redirect to dashboard
  if (!isRootAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Is root admin, render children
  return <>{children}</>;
};

export default RootOnlyGuard;
